import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useDispatch } from "react-redux";
import { Button } from '@mui/material';
import { makeStyles } from '@mui/styles';

import {Alert} from '@mui/material';
import {Cancel} from '@mui/icons-material';
import {Snackbar } from '@mui/material';
import styled from "styled-components";
import { filter, find, get } from "lodash";
import { updateUI } from "store/UI/actions";
import { useAllBook } from "store/books/selectors";
import { useAllDistrictTeacher, useCurrentUser, useUserProfileConfig } from "store/users/selectors";
import { useSuperLesson } from "store/SuperLesson/selectors";
import CreateLessonModal from "./CreateLessonModal";
import { getAwsAuthToken } from "utils/lib/authHelper";
import sysConf from "config";
import * as Sentry from '@sentry/react';
import SentryWrap from 'components/Sentry';
import {
  handleGetSuperLesson,
  handleLanguageTranslator,
} from "store/SuperLesson/thunks";
import { apis } from "utils/lib/apis";
import { cleanHTMLString } from "utils/methods/textMethod";
import { useAlert } from "components/UI/alertSakeBar/alertProvider";
import usePopUpAtOnce from "components/hooks/usePopUpAtOnce";
import useBadWords from "components/hooks/words/badWords";

//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------

//  -- Components ---------------------

//  -- Constants ---------------------






// const ModalContent = styled.div`
//   left: 50%;
//   max-width: 544px;
//   min-width: 450px;
//   padding: 0px 24px;
//   position: absolute;
//   border-radius: 10px;
//   top: 50%;
//   transform: translate(-50%, -50%);
//   background-color: #fff;
//   padding: 10px;
// `;

// Super-lession css
const ModalSuperPlane = styled.div`
  align-items: center;
  background-color: #000f4c;
  border-radius: 3px;
  display: inline-flex;
  flex-direction: column;
  left: 50%;
  max-width: 320px !important;
  padding: 24px 28px;
  position: absolute;
  text-align: center;
  top: 50%;
  transform: translate(-50%, -50%);
`;

// end Super-lession css

const useStyles = makeStyles({
  disabledButton: {
    color: "white", // Text color when disabled
    "&.Mui-disabled": {
      color: "white", // Ensures the color remains white even if the button is disabled
    },
  },
});

const SuperLesson = ({
  content,
  superLessonData,
  bookId,
  pageId,
  style,
  setVocModal,
  viewLesson,
  showModal,
  data,
  onLessonOpen = () => null,
  onSuperLessonOpen = () => null,
  onViewShowData = () => null,
  differentiationOpen,
  from,
  openSuperLessonToolModal,
  setToolsDropdown,
  setOpenSuperLessonToolModal,
  mediaQuery,
  DisplaySuperLessonAndDiff
}) => {
  const showAlert = useAlert();
  const classes = useStyles();
  const currentUser = useCurrentUser();
  const superLesson = useSuperLesson();
  const allDistrictTeacher = useAllDistrictTeacher();
  const [alertSakeBar, setAlertSakeBar] = useState({
    open: false,
    message: "",
    severity: "success",
  });
  const dispatch = useDispatch();
  const [loader, setLoader] = useState(false);
  const [superLession, setSuperLession] = useState(false);
  const [showReplacementMessage, setShowReplacementMessage] = useState(false);
  const [createLesson, setCreateLesson] = useState(false);
  const filterLesson = find(superLesson, (data) => data?.userId === currentUser?.id && data?.access_by?.includes(currentUser?.id)) || {};
  const filterShareLesson = filter(superLesson, (data) => data?.userId !== currentUser?.id && data?.access_by?.includes(currentUser?.id)) || [];
  const [filterMyData, setFilterMyData] = useState(filterLesson);
  const [filterSharedLesson, setFilterSharedLesson] = useState(filterShareLesson);
  const filteredSharedLesson = useMemo(() => {
    return filterSharedLesson.filter((item) => {
      const findShareBy = allDistrictTeacher.find((obj) => item.userId === obj?.id);
      return findShareBy !== undefined;
    });
  }, [filterSharedLesson, allDistrictTeacher]);
  const { isAiPermissionEnabled } = useUserProfileConfig();
  const {getTextFromHtml} = useBadWords();

  const [message, setMessage] = useState('');
  const [response, setResponse] = useState('');

  const booksAllList = useAllBook()
  const isCanvasUser  = !!get(currentUser,"canvas_id")
  const {updatePopUpAtOnce} = usePopUpAtOnce();

  const getNumberMask = useCallback((_page) => {
    let book = find(booksAllList, k => k.id == bookId)
    if (book) {
      let numberMask = find(book.pages, k => k.pageId == _page)
      if (numberMask) {
        if (numberMask.NumberMasked)
          return numberMask.NumberMasked
        else
          return _page;
      } else {
        return _page;
      }
    } else {
      return _page;
    }
  }, [bookId, booksAllList])

  const getPageInfo = useCallback(() => {
    const mask_from = getNumberMask(superLessonData?.from)
    const mask_to = getNumberMask(superLessonData?.to)
    return mask_from && mask_to ? `(P. ${mask_from}-${mask_to})` : ''
  }, [superLessonData])
  useEffect(() => {
    setFilterSharedLesson(filterShareLesson);
    setFilterMyData(filterLesson);
  }, [superLesson])

  useEffect(() => {
    onFetchLesson();
  }, [pageId, bookId]);


  const onFetchLesson = async (type) => {
    const data = {
      bookId: bookId,
      pageId: pageId,
      userId: currentUser.id,
    };
    const result = await dispatch(handleGetSuperLesson(data));
    if(Array.isArray(result) && type === "stream"){
      const filteredResult = result.find((x) => x?.bookId == bookId && x?.pageId == pageId && x?.userId == currentUser.id);
      if(filteredResult && filteredResult?.super_data?.language !== "English"){
      showAlert("Generating translation for English","success");
      await dispatch(handleLanguageTranslator(filteredResult?.id))
    }
    }
  };
  


  const closeAlert = () => {
    setAlertSakeBar({ open: false, message: "", severity: "success" });
  };

  async function streamData(inputData, onChunk, LIMIT = 0) {
    try {
      const prodUrl = `${sysConf.apiGateway.AI_BASE_NODE_URL}/SuperLessonStream/super-lesson-stream`;
      const localUrl = `http://localhost:4000/SuperLessonStream/super-lesson-stream`;
      const token = await getAwsAuthToken();
      const response = await fetch(prodUrl, {
        method: 'POST',
        headers: { 
          'Content-Type': 'application/json',
          "x-auth-source": sysConf.isDev ? "test" : "prod",
          'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify(inputData),
      });

      if (!response.ok || !response.body) {
        throw new Error('Stream failed to start');
      }

      const reader = response.body.getReader();
      const decoder = new TextDecoder('utf-8');
      let buffer = '';
      let fullTextAccumulator = '';
      while (true) {
        const { done, value } = await reader.read();
        if (done) break;

        const text = decoder.decode(value);
        const lines = text.split('\n').filter(Boolean);

        for (const line of lines) {
          const payload = line.replace(/^data:\s*/, '').trim();
          if (line.startsWith('data:')) {
            try {
              const parsed = JSON.parse(payload);
              if (parsed?.type === 'error') {
                const blockedMessage =
                  parsed.code === 'INAPPROPRIATE_CONTENT'
                    ? parsed.message || 'Lo siento, pero no te puedo ayudar con eso'
                    : parsed.message || 'Failed to create lesson. Please try again.';
                showAlert(blockedMessage, 'error');
                updatePopUpAtOnce(false);
                setCreateLesson(false);
                onSuperLessonOpen(false)
                setLoader(false);
                await dispatch(updateUI({ openSuperLesson: false }));
                return;
              }
            } catch {
              // not a JSON payload
            }
          }
          if (line.startsWith('data:') && payload === '[DONE]') {
            const getText = getTextFromHtml(fullTextAccumulator);
            if(getText.toLowerCase().includes("i'm sorry") && LIMIT < 3){
              showAlert("I'm sorry, I can't assist with that request.AI is generating again.. please wait","error");
              await streamData(inputData, onChunk, LIMIT + 1);
              return;
            }
            if(inputData?.super_data?.language !== "English"){
               onFetchLesson("stream");
            }else{
              onFetchLesson();
            }
            if (onChunk) {
              await onChunk(cleanHTMLString(fullTextAccumulator));
            }
            setAlertSakeBar({ open: true, message: 'Created Successfully', severity: 'success' });
            setCreateLesson(false);
            setLoader(false);
            return;
          }
          if (payload === '[ERROR]') {
            console.error('Stream returned an error signal.');
            setAlertSakeBar({ open: true, message: 'Failed to create lesson. Please try again.', severity: 'error' });
            setCreateLesson(false);
            setLoader(false);
            await dispatch(updateUI({ openSuperLesson: false }));
            return;
          }
          if (payload && payload !== '[DONE]' && payload !== '[ERROR]' && !payload.startsWith('{')) {
            fullTextAccumulator += line.replace('data: ', '');
          }
        }
      }
    } catch (error) {
      console.error('Stream error:', error);
      setAlertSakeBar({
        open: true,
        message: 'Failed to create lesson. Please try again.',
        severity: 'error',
      });
      setCreateLesson(false);
      setLoader(false);
      Sentry.captureException(`Error in super lesson stream: ${error}`);
    }
  }

  
  const onLessonAi = async (super_data) => {
    if (!isAiPermissionEnabled) {
      showAlert('Please enable AI permission to generate content using AI.', 'error');
      return;
    }
    const { limit, ...superLessonPayload } = filterMyData;
    const data = {
      ...superLessonPayload,
      bookId,
      pageId,
      from_page: super_data.from_page || superLessonData.from,
      to_page: super_data.to_page || superLessonData.to,
      userId: currentUser.id,
      super_data,
      access_by: [currentUser.id],
      mode: import.meta.env.VITE_APP_STAGE?.trim() === "prod" ? "prod" : "dev",
    };
  
    setLoader(true);
    let fullHTML = "";
  
    await streamData(data, async (chunk) => {
      fullHTML += chunk;
        setCreateLesson(false);
        await dispatch(updateUI({ openSuperLesson: true }));
        onLessonOpen();
        setLoader(false);
        onViewShowData(chunk);
    });
  };

  useEffect(()=>{
    if(!viewLesson && openSuperLessonToolModal){
      setToolsDropdown(false);
      setOpenSuperLessonToolModal(false);
      setSuperLession(!superLession);
      setFilterMyData(filterLesson);
      setFilterSharedLesson(filterShareLesson);
      onFetchLesson()
      setShowReplacementMessage(false)
      onSuperLessonOpen(!superLession);
    }
     
  },[openSuperLessonToolModal])

  const handleSuperLesson = () => {
    if (differentiationOpen) {
      setAlertSakeBar({
        open: true,
        message:
          "Please close the Differentiation, to open the SuperLesson",
        severity: "error",
      });
    } else {
      if (!viewLesson) {
        setSuperLession(!superLession);
        setFilterMyData(filterLesson);
        setFilterSharedLesson(filterShareLesson);
        onFetchLesson()
        setShowReplacementMessage(false)
        onSuperLessonOpen(!superLession);
      }
    }
  };
  const handleCreateNewLesson = () => {
    if(!isAiPermissionEnabled){
      showAlert('Please enable AI permission to generate content using AI.', 'error');
      return;
    }
    {/*----------------------------------Remove limit for one month -----------------------*/ }
    // if (filterMyData?.limit >= 2) {
    //   setAlertSakeBar({
    //     open: true,
    //     message:
    //       "you've reached the limit for creating super lessons on this page today.",
    //     severity: "error",
    //   });
    //   return;
    // }
    if (filterMyData?.id) {
      setShowReplacementMessage(true);
    } else {
      setCreateLesson(true);
      setSuperLession(false);
    }
  };
  const handleMyLession = () => {
    setCreateLesson(true);
    setSuperLession(false);
    setShowReplacementMessage(false);
  };
  const getMaskIdFrom = get(
    find(get(data, "content"), (k) => k.pageId === superLessonData?.from),
    "numberMasked",
    superLessonData?.from
  );

  const getMaskIdTo = get(
    find(get(data, "content"), (k) => k.pageId === superLessonData?.to),
    "numberMasked",
    superLessonData?.to
  );

  const [isMobile, setIsMobile] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  
  return (
    <SentryWrap>
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        open={alertSakeBar.open}
        autoHideDuration={3000}
        onClose={closeAlert}
        className="snackbarAddOn"
      >
        <Alert
          onClose={() => {
            setAlertSakeBar({ open: false, message: "" });
          }}
          severity={alertSakeBar.severity}
        >
          <strong>ALERT:</strong> {alertSakeBar.message}
        </Alert>
      </Snackbar>
      {/* <Tooltip title={`Super Lesson  ${getPageInfo()}`}> */}
      {/* {(isMobile >= mediaQuery) || !DisplaySuperLessonAndDiff  && (
              <Button
              style={{ minWidth: "unset", height: "36px", whiteSpace: "nowrap", borderRadius: "0px !important", ...(style ? style : {}) }}
              onClick={handleSuperLesson}
              // className="vocabularyBtn vocDeskTab scheduledWeb superLessonButton"
              className={`vocabularyBtn vocDeskTab scheduledWeb superLessonButton ${isMobile <= 768 || from !== 'ebook' ? 'informateSupLessonAndDiff' : 'ebookSupLessonAndDiff'}`}
              >
              {(isMobile <= 768 || from !== 'ebook') ? `Super lesson` : `Super Lesson ${getPageInfo()}`}
              </Button>
      )}

{!(isMobile >= mediaQuery) || !DisplaySuperLessonAndDiff  && (
              <Button
              style={{ minWidth: "unset", height: "36px", whiteSpace: "nowrap", borderRadius: "0px !important", ...(style ? style : {}) }}
              onClick={handleSuperLesson}
              // className="vocabularyBtn vocDeskTab scheduledWeb superLessonButton"
              className={`vocabularyBtn vocDeskTab scheduledWeb superLessonButton ${isMobile <= 768 || from !== 'ebook' ? 'informateSupLessonAndDiff' : 'ebookSupLessonAndDiff'}`}
              >
              {(isMobile <= 768 || from !== 'ebook') ? `Super lesson` : `Super Lesson ${getPageInfo()}`}
              </Button>
      )} */}

      {/* {!DisplaySuperLessonAndDiff  && (
          <Button
          style={{ minWidth: "unset", height: "36px", whiteSpace: "nowrap", borderRadius: "0px !important", ...(style ? style : {}) }}
          onClick={handleSuperLesson}
          className="vocabularyBtn vocDeskTab scheduledWeb superLessonButton"
          >
          {(isMobile <= 768 || from !== 'ebook') ? `Super lesson` : `Super Lesson ${getPageInfo()}`}
          </Button>
      )} */}
     
      {/* </Tooltip> */}
      <>
        {superLession && (
          <div
            // className="superLessionModal"
            className="superLessionModal"
          // style={{ height: '100%', width: '100%', backgroundColor: "transparent" }}
          >
            <ModalSuperPlane 
            // className="superLessionContents"
            className="superLessionContents"
            >
              <span onClick={async () => {
                updatePopUpAtOnce(false)
                setSuperLession(false);
                onSuperLessonOpen(false);
                setShowReplacementMessage(false)
                await dispatch(updateUI({openSuperLesson: false}))
              }}>
                <Cancel
                  style={{
                    position: "absolute",
                    right: -7,
                    top: -7,
                    fontSize: 22,
                    color: "red",
                    background: "white",
                    borderRadius: 20,
                    cursor: "pointer",
                  }}
                />
              </span>
              <Button
                className={classes.disabledButton}
                onClick={async () => {
                  updatePopUpAtOnce(true);
                  onLessonOpen("shared");
                  setSuperLession(false);
                  await dispatch(updateUI({openSuperLesson: true}))
                }}
                disabled={filteredSharedLesson?.length === 0}
                style={{ opacity: filteredSharedLesson?.length === 0 ? 0.6 : 1 }}
              >
                See shared lesson
              </Button>
              <Button
                className={classes.disabledButton}
                onClick={async () => {
                  updatePopUpAtOnce(true);
                  onLessonOpen();
                  setSuperLession(false);
                  await dispatch(updateUI({openSuperLesson: true}))
                }}
                disabled={!filterMyData ||
                  !filterMyData.id ||
                  (typeof filterMyData === 'object' && Object.keys(filterMyData).length === 0)}
                style={{
                  opacity: !filterMyData ||
                    !filterMyData.id ||
                    (typeof filterMyData === 'object' && Object.keys(filterMyData).length === 0) ? 0.6 : 1
                }}
              >
                See saved lesson
              </Button>
              <Button onClick={handleCreateNewLesson}>
                Create a new lesson
              </Button>
            </ModalSuperPlane>
          </div>
        )}
        {showReplacementMessage && filterMyData?.id && (
          <div className="allCreateLession">
            <div 
            // className="creatLessionSection"
            className="creatLessionSection"
            >
              <p>
                By creating a new lesson, your saved lesson will be replaced
              </p>
              <div className="createBtnSection">
                <Button onClick={handleMyLession}>I agree</Button>
                <Button onClick={() => setShowReplacementMessage(false)}>
                  Cancel
                </Button>
              </div>
            </div>
          </div>
        )}
        {showModal && (
            <CreateLessonModal
              open={createLesson}
              onClose={() => {
                updatePopUpAtOnce(false);
                setCreateLesson(false)
                onSuperLessonOpen(false);
              }}
              loader={loader}
              onCreate={async (payload) => {
                {/*----------------------------------Remove limit for one month -----------------------*/ }
                // if (filterMyData?.limit >= 2) {
                //   setAlertSakeBar({
                //     open: true,
                //     message:
                //       "you've reached the limit for creating super lessons on this page today.",
                //     severity: "error",
                //   });
                //   return;
                // }
                await onLessonAi(payload);
              }}
              superLessonConfig={{
                from: superLessonData?.from,
                to: superLessonData?.to
              }}
              from={from}
              isCanvasUser={isCanvasUser}
              data={data}
              content={content}
              page={pageId}
              chapter={bookId}
              is_balcon={from == 'balcon'}
            />
          )
        }

      </>
    </SentryWrap>
  );
};

export default SuperLesson;